import React, {useRef, useEffect} from 'react';
import { VegaTabGroup } from "@heartlandone/vega-react";

const MainMenu = ({category, onChange}) => {
  const tabGroupRef = useRef(null);

  useEffect(() => {
    tabGroupRef.current.componentOnReady().then(() => {
      tabGroupRef.current.shadowRoot.querySelector('vega-card').style.display = 'none';
    })
  }, [tabGroupRef]);
  return (
    <VegaTabGroup
      selected-tab-data-target={
        category || "Registered"
      }
      ref={tabGroupRef}
      gap="size-8"
      show-close-button="false"
      tabItems={[
        { label: "My Registered Activity", dataTarget: "Registered" },
        {
          label: "My Published Activity",
          dataTarget: "Published"
        },
        { label: "My Favorite Activity", dataTarget: "Favorite" },
      ]}
      onVegaClick={onChange}
    ></VegaTabGroup>
  );
}

export default MainMenu;
